export class CommonDetailsModel {

    public id: number;
    public phone: string;
    public email: string;
    public agreementNo: string;
    public createdTime: string;
    public modifiedTime: string;
    public responsibleUser: object;
    public status: string;
    public statusUpdatedBy: string;
    public isFatcaResident: boolean;
    public isBankClient: boolean;
    public riskRateId: number;
    public region: number;
    public creatorDepartmentId: number;

    constructor(obj?: any) {
        this.id                     = obj && obj.id                     || null;
        this.phone                  = obj && obj.phone                  || '';
        this.email                  = obj && obj.email                  || '';
        this.agreementNo            = obj && obj.agreementNo            || '';
        this.createdTime            = obj && obj.createdTime            || '';
        this.modifiedTime           = obj && obj.modifiedTime           || '';
        this.responsibleUser        = obj && obj.responsibleUser        || null;
        this.status                 = obj && obj.status                 || '';
        this.statusUpdatedBy        = obj && obj.statusUpdatedBy        || '';
        this.isFatcaResident        = obj && obj.isFatcaResident        || '';
        this.isBankClient           = obj && obj.isBankClient           || '';
        this.riskRateId             = obj && obj.riskRateId             || null;
        this.region                 = obj && obj.region                 || null;
        this.creatorDepartmentId    = obj && obj.creatorDepartmentId    || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/common-details.model.ts